module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/hero-title-img@1x.43234a1.png";